module.exports = __webpack_public_path__ + "img/session-expired.5f1ebc6a.svg";